import { postCheckoutDataForValidation } from '@/api/legacyAPI';
import { LocalStorageService } from '@/core/services/localStorageService';

const BASE_FORM_KEY = 'baseFormValues';

export const CheckoutFormDataService = () => {

    const get = () => {
        const baseForm = LocalStorageService.get(BASE_FORM_KEY) ?? {}
        return { ...baseForm}
    }

    const store = (data) => {
        const baseForm = {
            name: data.name,
            surname: data.surname,
            father_name: data.father_name,
            email: data.email,
            cellphone_num: data.cellphone_num,
            address: data.address,
            address_no: data.address_no,
            tax_no: data.tax_no,
            license_plate: data.license_plate,
            usedVehicle: data.usedVehicle,
            occupation_type: data.occupation_type,
            startDate: data.startDate,
        }
        if (data.usedVehicle) {
            baseForm.transferDate = data.transferDate;
        }

        LocalStorageService.set(BASE_FORM_KEY, baseForm )
    }
    
    const clear = () => {
        LocalStorageService.remove(BASE_FORM_KEY);
    }

    const postForm = async (category, dc, fid, data, optins, companySiteId, urlExt) => {
        return await postCheckoutDataForValidation(category, dc, fid, data, optins, companySiteId, urlExt)
    };

    return {
        get,
        store,
        clear,
        postForm
    }
}
